module.exports = __webpack_public_path__ + "img/PM2.5mg.7680ce53.png";